"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (ref) {
  return ref ? ref.ownerDocument.defaultView : window;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/view/get-window-from-ref.js
// module id = 3065
// module chunks = 0